import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "townhome-level" }
const _hoisted_2 = { class: "townhome-level-right" }
const _hoisted_3 = ["onClick"]

import { Levels } from '@/constant/enums';
import { computed, ref, toRefs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TownHomeLevel',
  props: {
    levels: {},
    printSelectedLevel: {}
  },
  emits: ['selectedLevel'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const { levels, printSelectedLevel } = toRefs(props);
const activeLevel = ref('');

const emits = __emit;

const currentActiveLevel = computed(() => {
  return printSelectedLevel.value
    ? printSelectedLevel.value
    : activeLevel.value;
});

const getLevelName = (level: string) => {
  return Levels[level];
};

const setActiveLevel = (level: string) => {
  activeLevel.value = activeLevel.value === level ? '' : level;
  emits('selectedLevel', activeLevel.value.trim());
};

__expose({
  setActiveLevel,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"townhome-level-left\" data-v-7122ee5d><i data-v-7122ee5d><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-layers-icon lucide-layers\" data-v-7122ee5d><path d=\"M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z\" data-v-7122ee5d></path><path d=\"M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12\" data-v-7122ee5d></path><path d=\"M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17\" data-v-7122ee5d></path></svg></i> LEVEL </div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(levels), (level, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["townhome-level-item", { 'item-active': currentActiveLevel.value === level }]),
          onClick: ($event: any) => (setActiveLevel(level))
        }, _toDisplayString(getLevelName(level)), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})